import React from 'react';

const Intro = () => {
    return (
        <div>
           <h1 className='font-bold'>Ganesh Pataiya</h1>
           <h2 className='mt-1 text-lg font-medium sm:text-xl'>UI/Front-End Developer</h2>
           <p className='mt-4 max-w-xs leading-normal'>I build accessible, pixel-perfect digital experiences for the web.</p>
        </div>
    );
};

export default Intro;